__turbopack_context__.v({
  "button": "index-module-scss-module__5PXiNa__button",
});
